import { useEffect } from "react";

/**
 * Public marketing landing page — full-viewport iframe hosting the static
 * marketing.html. This keeps the marketing site's HTML/CSS/JS completely
 * isolated from the React admin bundle while presenting `/` as the clean
 * public URL.
 */
export default function LandingPage() {
  useEffect(() => {
    document.title = "Ratezy — Reviews made easy";
    // Blank background so iframe load flash is invisible
    document.body.style.margin = "0";
    document.body.style.background = "#07080a";
    document.documentElement.style.background = "#07080a";
  }, []);
  return (
    <iframe
      title="Ratezy"
      src="/_static/marketing.html"
      data-testid="marketing-frame"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: 0,
        display: "block",
      }}
    />
  );
}
